// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2vZAI","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Yzr8"};